import http from './http' // needs this file in the same directory
// import {The_Ability} from '../store/index'

export default {
  indexQrcode(cf_id, filter){
    return http.get(`/custom_fields/${cf_id}/custom_values.pdf`, {params: {...filter}});
  },
  index(){
    return http.get(`/custom_values`);
  },
  indexByModel(model, model_id){
    model = model || 'custom_fields'
    return http.get(`/${model}/${model_id}/custom_values`);
  },

  show(item_id){
    return http.get(`/custom_values/`+item_id);
  },

  create(new_item){
    // if (The_Ability.can('create', 'custom_value')){
      return http.post(`/custom_values`,{
        custom_value:{ 
          main:            new_item.main,
          content:         new_item.content,
          custom_field_id: new_item.custom_field_id,
          status:          1,
        }
      });
    // } else {
    //   return false
    // }
  },

  update(update_item){
    // if (The_Ability.can('update', 'custom_value')){
      return http.put(`/custom_values/${update_item.id}`,{
        custom_value:{ 
          id: update_item.id,

          main:            update_item.main,
          content:         update_item.content,
          custom_value_id: update_item.custom_value_id,
          status:          update_item.status,
        }
      });
    // } else {
    //   return false
    // }
  },

  importCsv({id, custom_values_attributes}){
    return http.post(`/custom_fields/${id}/bulk_import`, {
      custom_field: {
        id,
        custom_values_attributes,
      }
    })
  },

  updateToDelete(update_item){
    return http.delete(`/custom_values/${update_item}`);
  },

}